import useSWR from 'swr';

import { IWidget } from 'domain/models';

export const useWidgets = (): IWidget[] => {
  const { data } = useSWR('/mock/widgets.json');

  return data as IWidget[];
};
